export type QualityQueue =
  | "UNQUALIFIED"
  | "QUALIFIED"
  | "CAPTURE_ISSUE"
  | "PENDING_REVIEW";

export type HistoryDays = 7 | 30;

export const queueMeta: Record<
  QualityQueue,
  { label: string; description: string; tone: "coral" | "mint" | "amber" | "blue" }
> = {
  UNQUALIFIED: { label: "不达标", description: "需要重点关注", tone: "coral" },
  QUALIFIED: { label: "达标", description: "符合出餐标准", tone: "mint" },
  CAPTURE_ISSUE: { label: "无效图片", description: "无效或非菜图片", tone: "amber" },
  PENDING_REVIEW: { label: "有效待识别", description: "尚未人工反馈", tone: "blue" },
};

export interface QualityQuery {
  date: string;
  queue: QualityQueue;
  page: number;
  pageSize: number;
  storeId?: string | number;
  dishId?: string | number;
}

export function buildQualityQuery(query: QualityQuery): Record<string, unknown> {
  return Object.fromEntries(
    Object.entries(query).filter(([, value]) => value !== undefined && value !== null && value !== "")
  );
}

export function buildHistoryQuery(query: {
  days: HistoryDays;
  storeId?: string | number;
  dishId?: string | number;
}): Record<string, unknown> {
  return Object.fromEntries(
    Object.entries(query).filter(([, value]) => value !== undefined && value !== null && value !== "")
  );
}

export function formatQualifiedRate(qualified: number, evaluated: number): number {
  if (!evaluated) return 0;
  return Math.round((qualified * 1000) / evaluated) / 10;
}

export function buildFeedbackPayload(agreed: boolean, note?: string | null) {
  const normalized = note?.trim();
  return { agreed, note: normalized || null };
}
